import { StyleSheet, type ViewStyle } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { CUSTOMIZER_SURFACE } from './characterCustomizer.constants';

export const getLayeredAvatarLabStyles = (theme: Theme) =>
  StyleSheet.create({
    root: {
      flex: 1,
      width: '100%',
      height: '100%',
      backgroundColor: CUSTOMIZER_SURFACE.stageBg,
      overflow: 'hidden',
    },
    header: {
      paddingHorizontal: 14,
      paddingBottom: 6,
      zIndex: 6,
    },
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    iconButton: {
      width: 40,
      height: 40,
      borderRadius: 9999,
      backgroundColor: CUSTOMIZER_SURFACE.iconBtnBg,
      alignItems: 'center',
      justifyContent: 'center',
    },
    saveButton: {
      backgroundColor: theme.primary,
      paddingHorizontal: 20,
      paddingVertical: 10,
      borderRadius: 12,
      shadowColor: theme.primary,
      shadowOpacity: 0.4,
      shadowRadius: 10,
      shadowOffset: { width: 0, height: 2 },
      elevation: 3,
    },
    saveButtonText: {
      color: theme.onPrimary,
      fontWeight: '700',
      fontSize: 14,
    },
    toggleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 10,
    },
    toggleSide: {
      flex: 1,
    },
    stage: {
      height: 236,
      flexShrink: 0,
      position: 'relative',
      overflow: 'hidden',
    },
    // Dressed-progress badge overlaid on the stage (moved off the header row so the
    // mode toggle never overlaps it). Sits top-right, clear of the centered character.
    badgeOnStage: {
      position: 'absolute',
      top: 10,
      right: 12,
      zIndex: 5,
    },
    stageCharacter: {
      ...StyleSheet.absoluteFillObject,
      alignItems: 'center',
      justifyContent: 'center',
      transform: [{ translateY: -8 }],
    },
    shop: {
      flex: 1,
      minHeight: 0,
      flexDirection: 'row',
      backgroundColor: CUSTOMIZER_SURFACE.shopBg,
      borderTopWidth: 1,
      borderTopColor: CUSTOMIZER_SURFACE.divider,
    },
    shopBody: {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
    },
    shopHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 14,
      paddingTop: 13,
      paddingBottom: 8,
    },
    shopTitle: {
      fontSize: 17,
      fontWeight: '800',
      color: theme.black,
      letterSpacing: -0.2,
    },
    surpriseButton: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      backgroundColor: CUSTOMIZER_SURFACE.surpriseBg,
      borderWidth: 1,
      borderColor: CUSTOMIZER_SURFACE.surpriseBorder,
      paddingHorizontal: 12,
      paddingVertical: 8,
      borderRadius: 9999,
    },
    surpriseText: {
      color: theme.primaryLight,
      fontWeight: '700',
      fontSize: 12.5,
    },
    gridContent: {
      paddingHorizontal: 9,
      paddingTop: 2,
      paddingBottom: 18,
    },
    gridCell: {
      flex: 1,
      paddingHorizontal: 5,
      paddingBottom: 10,
    },
    readyScroll: {
      flex: 1,
      minHeight: 0,
      backgroundColor: CUSTOMIZER_SURFACE.shopBg,
      borderTopWidth: 1,
      borderTopColor: CUSTOMIZER_SURFACE.divider,
    },
    readyContent: {
      padding: 14,
    },
  });

export type LayeredAvatarLabStyles = ReturnType<typeof getLayeredAvatarLabStyles>;

/** Top padding follows the safe-area inset (header sits below the notch). */
export function getStageHeaderPadStyle(topInset: number): ViewStyle {
  return { paddingTop: topInset + 12 };
}
